<app-modal>
  <h4 modal-title>Afbeelding zoeken</h4>

  <div modal-body>
    <!-- Search Form -->
    <form [formGroup]="searchForm" (ngSubmit)="search(1)">
      <div class="row mb-3">
        <div class="col-12">
          <div class="input-group input-group-sm">
            <input
              #searchInput
              type="text"
              class="form-control form-control-sm"
              formControlName="query"
              placeholder="Zoek naar afbeeldingen..."
            />
            <button type="submit" class="btn btn-primary btn-sm" [disabled]="loading">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </form>

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Laden...</span>
      </div>
    </div>

    <!-- Results Info -->
    <div *ngIf="!loading && images.length > 0" class="mb-3">
      <p class="text-muted small">
        <strong>{{ total }}</strong> resultaten - Pagina {{ currentPage }} van {{ totalPages }}
      </p>
    </div>

    <!-- Image Grid -->
    <div *ngIf="!loading && images.length > 0" class="image-grid">
      <div
        *ngFor="let image of images"
        class="image-item"
        (click)="selectAndConfirm(image)"
        title="Klik om te selecteren"
      >
        <img [src]="image.urls.regular" [alt]="image.alt" loading="lazy" />
        <div class="image-overlay">
          <div class="image-info">
            <p class="photographer">
              <i class="fas fa-camera me-1"></i>
              {{ image.photographer }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- No Results - only show after actual search -->
    <div *ngIf="!loading && images.length === 0 && hasSearched" class="text-center py-5">
      <i class="fas fa-image fa-3x text-muted mb-3"></i>
      <p class="text-muted">Geen afbeeldingen gevonden voor "{{ searchForm.value.query }}"</p>
    </div>

    <!-- Initial state - before first search -->
    <div *ngIf="!loading && images.length === 0 && !hasSearched" class="text-center py-5">
      <i class="fas fa-search fa-3x text-muted mb-3"></i>
      <p class="text-muted">Voer een zoekterm in om afbeeldingen te vinden</p>
    </div>

    <!-- Load More Button -->
    <div *ngIf="images.length > 0 && currentPage < totalPages" class="text-center mt-4">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="loadMore()"
        [disabled]="loadingMore"
      >
        <span *ngIf="!loadingMore">
          <i class="fas fa-plus-circle me-2"></i>
          Laad meer foto's
        </span>
        <span *ngIf="loadingMore">
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          Laden...
        </span>
      </button>
      <p class="text-muted small mt-2">{{ images.length }} van {{ total }} foto's geladen</p>
    </div>

    <!-- Image Provider Attribution -->
    <div class="unsplash-attribution mt-4 pt-3 border-top">
      <p class="text-muted small mb-0">
        <i class="fas fa-info-circle me-1"></i>
        Foto's geleverd door
        <a [href]="getProviderUrl()" target="_blank" rel="noopener noreferrer">
          {{ getProviderName() }}
        </a>
      </p>
    </div>
  </div>
</app-modal>
